import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Marketplace, Strategy } from "@front/m19-api-client";
import { TacosStrategiesService } from "@front/m19-services";
import { MODAL_DATA, ModalOptions, ModalRef } from "@front/m19-ui";
import { ProductThumbnailComponent } from "@m19-board/product-view/product-thumbnail.component";
import { StrategyLinkComponent } from "@m19-board/shared/strategy-link/strategy-link.component";

@Component({
  selector: "app-asin-strategy-usage",
  imports: [CommonModule, ProductThumbnailComponent, StrategyLinkComponent],
  templateUrl: "./asin-strategy-usage-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsinStrategyUsageComponent {
  static readonly defaultModalOptions: Omit<ModalOptions<unknown>, "data"> = { height: "fill" };

  protected readonly modalData = inject(MODAL_DATA) as AsinStrategyUsageModalData;
  modalRef = inject(ModalRef);

  private tacosStrategiesService = inject(TacosStrategiesService);

  asinsUsedInAdvertising: Signal<Map<string, Strategy[]> | undefined> = toSignal(
    this.tacosStrategiesService.asinsUsedInAdvertising$,
  );

  asinsUsedInTacos: Signal<Map<string, Strategy[]> | undefined> = toSignal(
    this.tacosStrategiesService.asinsUsedInTacos$,
  );

  usedStrategies = computed<Map<string, Strategy[]>>(() => {
    if (this.modalData?.isTacosStrategy) {
      return this.asinsUsedInAdvertising() ?? new Map();
    }
    return this.asinsUsedInTacos() ?? new Map();
  });
}

export interface AsinStrategyUsageModalData {
  accountId: string;
  marketplace: Marketplace;
  isTacosStrategy: boolean;
}
